<div class="add-client-wrapper" [formGroup]="form">
  <div class="add-client-fields-wrapper">
    <div *ngIf="!effectiveTourOperator" class="field-combo">
      <div class="field-wrapper name-input">
        <label for="firstname">
          {{ "Name" | translate }}
        </label>
        <input
          formControlName="firstName"
          id="firstname"
          matInput
          type="text"
        />
      </div>

      <div class="field-wrapper surname-input">
        <label for="lastname">
          {{ "Surname" | translate }}
        </label>
        <input formControlName="lastName" id="lastname" matInput type="text" />
      </div>
    </div>

    <div *ngIf="effectiveTourOperator" class="field-combo">
      <div class="field-wrapper name-input">
        <label for="firstnameTourOperator">
          {{ "Business name" | translate }}
        </label>
        <input
          formControlName="firstName"
          id="firstnameTourOperator"
          matInput
          style="width: 420px"
          type="text"
        />
      </div>
    </div>

    <div class="field-combo" style="display: flex;">
      <div class="field-wrapper phone-input" style="margin-left: 0">
        <label class="label-countries">{{
          "International prefix" | translate
        }}</label>
        <ws-selector
          [options]="countriesPrefixData"
          [selected]="selectedPrefix"
          (selectedChange)="onPrefixSelected($event)"
          [formatter]="prefixFormatter"
          [placeholder]="'International prefix' | translate"
        ></ws-selector>
      </div>

      <div class="field-wrapper phone-input">
        <label for="phone">{{ "Phone" | translate }}</label>
        <input
          formControlName="phoneNumber"
          mask="999999999999999999999999999999999999999999999"
          matInput
          type="tel"
          [prefix]="getPrefixWithPlus()"
          id="phone"
        />
      </div>
    </div>

    <div class="field-combo">
      <div class="field-wrapper email-input">
        <label for="email">
          {{ "Email" | translate }}
        </label>
        <input
          matInput
          id="email"
          type="text"
          formControlName="email"
          style="width: 420px"
        />
      </div>
    </div>

    <div class="field-combo">
      <div class="field-wrapper email-input">
        <label for="email">
          {{ "Country of Residence" | translate }}
        </label>
        <input
          (input)="filterCountries($event)"
          type="text"
          matInput
          formControlName="countryIso"
          [matAutocomplete]="autocompleteCountry"
          style="width: 420px"
        />
        <mat-autocomplete
          #autocompleteCountry="matAutocomplete"
          style="border: none; box-shadow: none"
          [displayWith]="displayCountry"
        >
          <mat-option
            *ngFor="let country of filteredCountriesIsoAndNames; let i = index"
            [value]="country.iso"
          >
            <ws-flag
              [countryCode]="country.iso"
              size="small"
              [showBorder]="true"
            ></ws-flag>
            {{ displayCountry("", country) }}
            <mat-divider
              style="background-color: #aaaaaa"
              *ngIf="
                filteredCountriesIsoAndNames.length > 3 &&
                i === 2 &&
                !form.get('countryIso')!.value
              "
            ></mat-divider>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>

    <div class="field-combo">
      <div class="field-wrapper manual-marketing-input">
        <mat-checkbox
          [disabled]="form.get('email')?.invalid || !form.get('email')?.value"
          formControlName="manualMarketing"
        >
          {{ "Manual marketing consent" | translate }}
        </mat-checkbox>
      </div>
    </div>

    <div *ngIf="effectiveTourOperator" class="field-combo">
      <div class="field-wrapper manual-marketing-input">
        <mat-checkbox [checked]="true" [disabled]="true">{{
          "Tour Operator" | translate
        }}</mat-checkbox>
      </div>
    </div>
  </div>

  <div class="actions-wrapper">
    <ws-button mat-stroked-button [disabled]="isSaving" (click)="cancelClicked()">{{
      "Cancel" | translate
    }}</ws-button>
    <ws-button
      mat-flat-button
      [disabled]="!form.valid || isSaving"
      (click)="saveClicked()"
      [callToActionType]="'primary'"
    >
      <span class="new-contact-save__row">
        <mat-spinner
          *ngIf="isSaving"
          class="new-contact-save__spinner"
          diameter="18"
        ></mat-spinner>
        <ng-container *ngIf="!isSaving">{{
          (contactIsNew ? "Add" : "Edit") | translate
        }}</ng-container>
        <ng-container *ngIf="isSaving">{{ "Saving..." | translate }}</ng-container>
      </span>
    </ws-button>
  </div>
</div>
